import { Component, OnDestroy, OnInit } from "@angular/core";
import { UserSerivice } from "../services/user.service";
import {
  catchError,
  defer,
  iif,
  map,
  of,
  Subject,
  switchMap,
  takeUntil,
} from "rxjs";
import { Router } from "@angular/router";

enum Status {
  Unknown = 1,
  WaitingApproval = 2,
  Submitted = 3,
  Active = 4,
}

@Component({
  selector: "app-user-account-status",
  templateUrl: "./user-account-status.component.html",
  styleUrls: ["./user-account-status.component.css"],
})
export class UserAccountStatusComponent implements OnInit, OnDestroy {
  constructor(private userService: UserSerivice, private route: Router) {}

  private __destroy$ = new Subject();

  userStatus = Status.Unknown;

  ngOnInit(): void {
    const add$ = this.userService
      .addUser()
      .pipe(map((_) => Status.Submitted))
      .pipe(
        catchError((e) => {
          return of(Status.Unknown);
        })
      );

    this.userService
      .getProfile()
      .pipe(
        takeUntil(this.__destroy$),
        switchMap((v) =>
          iif(
            () => !!v,
            defer(() => of(v.active ? Status.Active : Status.WaitingApproval)),
            add$
          )
        )
      )
      .subscribe((status) => {
        if (status === Status.Active) {
          this.route.navigateByUrl("/");
          return;
        }

        this.userStatus = status;
      });
  }

  ngOnDestroy(): void {
    this.__destroy$.complete();
  }
}
